import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#fbfaf8',
    color100: '#f0f3f3',
    color200: '#f4f1ea',
    color300: '#c6c4bf',
    color400: '#979694',
    color500: '#696969',
    color600: '#545454',
    color700: '#464646',
    color800: '#2a2a2a',
    color900: '#151515'
  },
  default: {
    color50: '#d5eaf0',
    color100: '#aad4e0',
    color200: '#80bfd1',
    color300: '#55a9c2',
    color400: '#2b94b2',
    color500: '#007ea3',
    color600: '#006582',
    color700: '#004c62',
    color800: '#003241',
    color900: '#001921'
  },
  accent: {
    color50: '#e6f3f0',
    color100: '#cde7e2',
    color200: '#b4dbd3',
    color300: '#9bcfc4',
    color400: '#82c3b6',
    color500: '#69b7a7',
    color600: '#549286',
    color700: '#3f6e64',
    color800: '#2a4943',
    color900: '#152521'
  },
  positive: {
    color50: '#e6f3f0',
    color100: '#cde7e2',
    color200: '#b4dbd3',
    color300: '#9bcfc4',
    color400: '#82c3b6',
    color500: '#69b7a7',
    color600: '#549286',
    color700: '#3f6e64',
    color800: '#2a4943',
    color900: '#152521'
  },
  negative: {
    color50: '#fde3d5',
    color100: '#fac7aa',
    color200: '#f8ab80',
    color300: '#f58f55',
    color400: '#f3732b',
    color500: '#f05700',
    color600: '#c04600',
    color700: '#903400',
    color800: '#602300',
    color900: '#301100'
  },
  special: {
    color50: '#fbead5',
    color100: '#f8d6aa',
    color200: '#f4c180',
    color300: '#f0ac55',
    color400: '#ed982b',
    color500: '#e98300',
    color600: '#ba6900',
    color700: '#8c4f00',
    color800: '#5d3400',
    color900: '#2f1a00'
  }
};

const variant: ACPVariant = {
  id: 'www.mysmartone.com',
  productTitle: 'Netspend smartOne Account',
  productType: 'award',
  accessDomain: {
    subdomain: 'www',
    domain: 'mysmartone',
    topLevelDomain: 'com'
  },
  colors,
  legacyAcpTheme: 'smartone',
  legacyAcpBrandName: 'smartone',
  legacyLegosTheme: 'smartone',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'light',
  contactInfo: {
    name: 'smartOne',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@mysmartone.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(877) 562-2235',
    phone: '8775622235',
    phone_international: '737-220-8956',
    balance_check_phone: '8663877363',
    balance_check_phone_formatted: '1-866-387-7363',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: false,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: true
    },
    misc: {
      layoutComponentOverride: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#0092BC',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.mysmartone.com/account/login',
      marketingSiteLinkText: 'mysmartone.com',
      locationSearchMax: '25'
    },
    content: {
      copyrightStatement:
        'Netspend Corporation All rights reserved worldwide. All other trademarks and service marks belong to their owners.'
    },
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
